import React from 'react';
import { TakeTourButton } from '../../tour';

/**
 * MyWorkHeader Component
 * Clean, minimal header matching specification requirement:
 * No global search, no global filters, no KPI cards.
 * Includes interactive Tour Guide button.
 */
export default function MyWorkHeader({ onNavigate = null }) {
    return (
        <div data-tour="mywork-header" className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-1">
            <div>
                <h1 className="text-3xl font-black text-[#003263] dark:text-[#a7c8ff] font-headline tracking-tight">
                    My Work
                </h1>
                <p className="text-[#424750] dark:text-slate-400 font-medium text-sm mt-1">
                    View and manage your assigned work, workload, and task progress.
                </p>
            </div>
            <div className="flex items-center gap-2">
                <TakeTourButton currentNav="mywork" onNavigate={onNavigate} />
            </div>
        </div>
    );
}
